import { render, staticRenderFns } from "./PersonalProfileTinsControl.vue?vue&type=template&id=22d5201b&"
import script from "./PersonalProfileTinsControl.vue?vue&type=script&lang=js&"
export * from "./PersonalProfileTinsControl.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports